module.exports = __webpack_public_path__ + "static/conversation-6af0f6b52c0aa3d8bf3f78a25a65a648.svg";